<div [ngClass]="{
  'is-unavailable': reward && reward.status === RewardStatus.UNAVAILABLE,
  'is-available': reward && (reward.status === RewardStatus.AVAILABLE || reward.status === RewardStatus.USABLE),
  'is-taken': reward && reward.status === RewardStatus.TAKEN,
  'is-last-element': isLastElement
  }" class="reward flex-shrink-0 flex flex-col h-full flex-1  px-[1rem] pt-[0.4rem] pb-[1rem] lg:px-[0.4rem] lg:pt-[0.2rem] lg:pb-[0.4rem] rounded-[1.6rem] lg:rounded-[1rem] w-[10.2rem] lg:w-[7.2rem] h-full bg-[linear-gradient(180deg,rgba(46,74,148,0.49)_0%,rgba(75,108,195,0.49)_100%)] before:bg-[linear-gradient(180deg,rgba(46,74,148,0.59)_0%,rgba(75,108,195,0.59)_100%)] custom-transition-bg"
  (click)="openAvatarBonusDialog()"
>
  <div class="flex flex-1 items-center justify-center">
    @if (reward) {
      <img class="pointer-events-none max-w-full h-full max-h-[6rem] lg:max-h-[3.5rem]"
        loading="lazy"
        [src]="reward.serviceItem.image.fileName | serviceItemImage"
        [alt]="reward.serviceItem.name"
      />
    } @else {
      <preload-rect
        [background]="'#243A76'"
        width="100%"
        height="100%"
        class="preload"
      />
    }
  </div>
  @if (reward && isAuthenticated && dailyRewardsState.conditionsMet()) {
    @if (reward.status === RewardStatus.AVAILABLE) {
      <button [class]="baseButtonClass" type="button"
        i18n="@@bonuses.daily_rewards.take_reward"
        [disabled]="isTakingReward()"
        [class.is-loading]="isTakingReward()"
        (click)="takeReward()"
      >Забрать</button>
    }

    @if (reward.status === RewardStatus.USABLE) {
      <button [class]="baseButtonClass" type="button"
        i18n="@@bonuses.daily_rewards.open_reward"
        (click)="useReward()"
      >Открыть</button>
    }

    @if (reward.status === RewardStatus.AVAILABLE_SOON || reward.status === RewardStatus.DEFAULT) {
      <div [class]="baseButtonClass">
        <span>
        {{ reward.day }}
          <ng-container i18n="@@bonuses.daily_rewards.day">день</ng-container>
        </span>
      </div>
    }

    @if (reward.status === RewardStatus.TAKEN) {
      <div [class]="baseButtonClass">
        <i class="!absolute !text-green-extra-2 text-[2rem] top-[1rem] right-[1rem] icon icon_checked-circle-bold
        custom-transition z-20 lg:top-[0.6rem] lg:right-[0.9rem]"></i>
        @if (isLg()) {
          <div class="bg-[url('/assets/images/bonuses-page/daily-reward/light-success.webp')] absolute top-0 right-0
          z-10 w-[8.5rem] h-[8.4rem] rounded-tr-[1.2rem]"
          ></div>
        }
        <span
          i18n="@@bonuses.daily_rewards.taken"
        >
          Получено
        </span>
      </div>
    }

    @if (reward.status === RewardStatus.UNAVAILABLE || (isNextAndUnavailable && !reward.depositConditionMet)) {
      <div 
        [tp]="depositConditionTooltip"
        tpVariation="dailyRewardsTooltip"
        tpPlacement="bottom"
        [class]="baseButtonClass"
      >
        <i class="icon icon_lock-bold-2 opacity-70"></i>
      </div>
    }
  } @else if (reward && isAuthenticated && !dailyRewardsState.conditionsMet()) {
    @if (isFirstElement) {
      <div [class]="baseButtonClass">
        <span>
        {{ reward.day }}
          <ng-container i18n="@@bonuses.daily_rewards.day">день</ng-container>
        </span>
      </div>
    } @else {
      <div [class]="baseButtonClass">
        <i class="icon icon_lock-bold-2 opacity-70"></i>
      </div>
    }
  } @else if (reward && !isAuthenticated) {
    <div [class]="baseButtonClass">
        <span>
        {{ reward.day }}
          <ng-container i18n="@@bonuses.daily_rewards.day">день</ng-container>
        </span>
    </div>
  } @else {
    <div [class]="baseButtonClass">
      <preload-rect
        width="80%"
        height="1.2rem"
        class="preload"
        [background]="'#243A76'"
      />
    </div>
  }
</div>

<div class="overflow-visible relative h-[0.8rem] mt-[1rem] flex items-center lg:mt-[0.8rem]">
  <div class="flex-grow relative">
    <div
      class="h-[0.8rem] w-full bg-dark-blue-extra-4 relative"
      [ngClass]="{
        '!bg-blue-extra': reward?.status === RewardStatus.TAKEN && !isLastAndActive,
        'active-half-line': isLastAndActive,
        'rounded-l-[0.3rem]': isFirstElement,
        'rounded-r-[0.3rem]': isLastElement
      }"
    ></div>

    @if (isLastAndActive) {
      <img
        loading="lazy"
        fetchpriority="low"
        src="/assets/images/bonuses-page/progress-cursor.webp"
        class="h-[2rem] absolute bottom-[-0.5rem] left-1/2 transform -translate-x-1/2 z-10"
        alt=""
      />
    }
  </div>
</div>

<ng-template #depositConditionTooltip>
  <div
    i18n="@@bonuses.daily_rewards.additional_conditions"
    [ngStyle]="{
      'font-weight': 500,
      'margin-bottom': '5px',
      'background': 'linear-gradient(180deg, #2E417C 0%, #3A529C 100%)'
    }"
  >Дополнительные условия</div>

  @if (reward) {
    <div
      i18n="@@bonuses.daily_rewards.deposit_condition"
      [ngStyle]="{
      'color': '#EBDDC8',
      'font-weight': 400,
      'margin-bottom': '5px'
    }"
    >
      Пополнить на <span class="strong">${{ reward.minDeposit | number }}</span> за
      <span class="strong">{{ reward.minDepositPeriod | number }}</span>
      {{ reward.minDepositPeriod | i18nPlural:daysPlurals }}
    </div>
  }
</ng-template>